import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee.items, ...t.marquee.items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 py-7 overflow-hidden bg-ink"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display italic text-2xl sm:text-3xl text-white/20 hover:text-copper transition-colors duration-500 px-10 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-copper/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
